import * as THREE from "../../../../libs/three.js/build/three.module.js";
import Sprite from  "../Sprite.js";
/* 
两种拖拽方式：
1 只依附在点云上
2 平行于镜头view移动 */






const geo = new THREE.PlaneBufferGeometry(1,1)
export default class HandleSprite extends Sprite{
    constructor(position,options={}){
        
        options.sizeInfo = {width2d:60} 
        super(options)
        this.position.copy(position);
         
        this.dragStyle =  options.dragStyle || 'default'    //'default'||'onPointCloud'  
        
        
        this.bindEvent()
        
        
    }
    
    
    bindEvent(){
        let projectedStart, pointerStart
        
        const drag = (e)=>{ 
            /* if(e.hoverViewport != e.drag.dragViewport){//不能使用e.dragViewport，要使用drag中的，因为drag中存储的要一直继承下来，不因mouseup了而改变。
                viewer.dispatchEvent({
                    type : "CursorChange", action : "add",  name:"polygon_AtWrongPlace"
                })
                return
            } */ 
            const camera = viewer.scene.getActiveCamera();
            if(projectedStart){
                let move2d = new THREE.Vector2().subVectors(e.pointer, pointerStart)
                let projectNow = projectedStart.clone()
                projectNow.x += move2d.x;
                projectNow.y += move2d.y; 
                let unprojected = projectNow.clone().unproject(camera);
                this.position.set(unprojected.x, unprojected.y, unprojected.z);
            }else{
                projectedStart = this.position.clone().project(camera);
                pointerStart = e.pointer.clone()
            }
             
            this.update()
            this.dispatchEvent({type:'dragged', position: this.position }) 
        }
        
        const drop = (e)=>{
            projectedStart = null, pointerStart = null
        }
        
        const mouseover = (e) => {  
            viewer.dispatchEvent({
                type : "CursorChange", action : "add",  name:"markerMove"
            }) 
        };
        const mouseleave = (e) => {  
            viewer.dispatchEvent({
                type : "CursorChange", action : "remove",  name:"markerMove"
            })
        } 
        
        this.addEventListener('drag', drag) 
        this.addEventListener('drop', drop)  
        this.addEventListener('mouseover', mouseover);
        this.addEventListener('mouseleave', mouseleave);
    }
    
}